export default {
  'menu.welcome': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.console': '管理',
  'menu.console.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': 'ワークプレース',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': 'ベーシックフォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の記入）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完了）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': 'ベーシックリスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト（記事）',
  'menu.list.search-list.projects': '検索リスト（プロジェクト）',
  'menu.list.search-list.applications': '検索リスト（アプリケーション）',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': 'ベーシックプロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.account.profile': 'プロフィール',
  'menu.console.agents': 'エージェント',
  'menu.console.agentDevice': 'エージェントデバイス',
  'menu.console.devices': 'デバイス',
  'menu.console.speakers': '話者認識',
  'menu.console.voiceClone': 'ボイスクローン',
  'menu.console.settings': '個人設定',
  'menu.admin': '管理者',
  'menu.admin.dashboard': 'ダッシュボード',
  'menu.admin.settings': '設定',
  'menu.admin.providers': 'モデルプロバイダー',
  'menu.admin.unbindDevice': 'デバイス解除',
  'menu.admin.userManage': 'ユーザー管理',
  'menu.admin.systemConfig': 'システム設定',
  'menu.admin.whiteList': 'ホワイトリスト',
  'menu.admin.opsManage': '運用',
  'menu.admin.recorderManage': 'レコーダー管理',
  'menu.admin.deviceManage': 'デバイス管理',

  'menu.console.agentSetting': 'エージェント設定',
  };
